import React, { useState, useEffect } from 'react';
import { getPayments } from '../../../api/PaymentsAPI'; // Use the new API file
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppPaginator from '../../AppPaginator';
import AppSearchBox from '../../AppSearchBox';
import PerPageBlock from '../../../components/common/PerPageBlock';
import { formatDateTime } from '../../../commonfunctions';

const PaymentsViewPage = () => {
    const [paymentsList, setPaymentsList] = useState({ data: [], last_page: 0 });
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const filters = { page: currentPage, per_page: perPage, search_term: searchTermCompleted };
        
        getPayments(filters, (response) => {
            setIsLoading(false);
            if (response.payments) {
                setPaymentsList(response.payments);
            }
        });
    }, [currentPage, perPage, searchTermCompleted]);


   

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Member Payments" />
                
                <div className="card">
                    <div className="card-header d-flex justify-content-between">
                        <div>
                            <h5>All Member Payments</h5>
                            <small className="text-muted">A read-only log of all 'credit' transactions from members.</small>
                        </div>
                        <div style={{ minWidth: '300px' }}>
                            <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />
                        </div>
                    </div>
                    <div className="card-body">
                        {isLoading ? (
                            <div className="text-center p-5"><div className="spinner-border"></div></div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Member Name</th>
                                            <th>Description</th>
                                            <th className="text-end">Amount (₹)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentsList.data.length > 0 ? paymentsList.data.map(tx => (
                                            <tr key={tx.id}>
                                                <td>{formatDateTime(tx.transaction_date)}</td>
                                                <td>{tx.user?.name || 'N/A'}</td>
                                                <td>{tx.description}</td>
                                                <td className="text-end text-success fw-bold">₹{tx.amount}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">No payments found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <div className="d-flex justify-content-between mt-3">
                            {paymentsList.data.length > 0 &&
                                <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                            }
                            <AppPaginator totalPages={paymentsList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PaymentsViewPage;